import { call, select } from 'redux-saga/effects';
import { getOBD as getOBDAda } from '@bitComponents/adabyron/manager';
import { URLS } from '../errorManagement/errorToPrint/errorTextsConstants';
import FrontSonda from '@gcloud-npm/utils.monitoring.front-sonda';

const contextStore = state => state.context.data;

const OBD_URL_DESTINATION_REGEX = /^https:\/\/(?:www\.movistar\.es|movistar\.es\.cert|movistar\.es\.inte|tcolgranja1\.es\.telefonica|tcolgranja2\.es\.telefonica|tcolgranjainactiva\.es\.telefonica)(?:\/[-A-Za-z0-9#]+)*\/?(?:\?[-A-Za-z0-9_]+=(?:[-A-Za-z0-9_;áéíóúÁÉÍÓÚ]|%20|%2F|%2F%23%2F|%C3%A1|%C3%A9|%C3%AD|%C3%B3|%C3%BA|%C3%81|%C3%89|%C3%8D|%C3%93|%C3%9A|%26|%3B)+(?:&[-A-Za-z0-9_]+=(?:[-A-Za-z0-9_;áéíóúÁÉÍÓÚ]|%20|%2F|%2F%23%2F|%C3%A1|%C3%A9|%C3%AD|%C3%B3|%C3%BA|%C3%81|%C3%89|%C3%8D|%C3%93|%C3%9A|%26|%3B)+)*)?$/;

export function* forceOBD(params) {
  const {
    url,
  } = params;
  const context = yield select(contextStore);
  
  const validUrl = OBD_URL_DESTINATION_REGEX.test(url);

  if(!validUrl) {
    const frontSonda = new FrontSonda({
      processName: 'forceOBD',
      filePath: 'bitSagas/forceOBD',
    });
    frontSonda.severalMessage({
      info: `La url no pasa la validacion de regex para OBD. Url: ${url}`,
    });
  }
  const getOBDParams = {
    forzarOBD: true,
    destino: validUrl ? url: URLS.VTL_CATALOG,
    destino2: validUrl ? url: URLS.VTL_CATALOG
  };

  const response = yield call(getOBDAda, getOBDParams, context);

  const { onboardingURL } = response;

  return onboardingURL;
}
